import {
    GridColDef,
    GridColTypeDef,
    GridFilterItem,
    GridSortCellParams,
} from "@mui/x-data-grid-pro";
import { get } from "lodash";
import { CUSTOM_FILTERS } from "../FilterOverride/CustomFilters";
import {
    DurationFilter,
    formatValueToDuration,
} from "../Formatters/DurationFormatter";

export const durationColumnType: GridColTypeDef = {
    sortComparator: (
        v1,
        v2,
        param1: GridSortCellParams,
        param2: GridSortCellParams,
    ): number => {
        const row1 = param1.api.getRow(param1.id);
        const row2 = param2.api.getRow(param2.id);

        const p1 = formatValueToDuration(get(row1, param1.field)?.toString());
        const p2 = formatValueToDuration(get(row2, param2.field)?.toString());

        return p1.localeCompare(p2);
    },
    valueGetter: (_, row, column, apiRef) => {
        const value = get(row, column.field);

        return formatValueToDuration(value);
    },
    filterOperators: [
        {
            label: "contains",
            value: "contains",
            getApplyFilterFn: (filterItem) => {
                if (
                    !filterItem.field ||
                    !filterItem.value ||
                    !filterItem.operator
                ) {
                    return null;
                }

                const filterRegex = new RegExp(
                    formatValueToDuration(filterItem.value),
                    "i",
                );
                return (rowValue): boolean => {
                    return filterRegex.test(rowValue?.toString() || "");
                };
            },
            InputComponent: DurationFilter,
        },
        {
            label: "equals",
            value: "equals",
            getApplyFilterFn: (
                filterItem: GridFilterItem,
                column: GridColDef,
            ) => {
                if (
                    !filterItem.field ||
                    !filterItem.value ||
                    !filterItem.operator
                ) {
                    return null;
                }
                return (rowValue): boolean => {
                    return (
                        formatValueToDuration(rowValue) ===
                        formatValueToDuration(filterItem.value)
                    );
                };
            },
            InputComponent: DurationFilter,
        },
        ...CUSTOM_FILTERS,
    ],
};
